import { jsx as r } from "react/jsx-runtime";
import { Login as f } from "../../Login/Login.js";
import "../../Login/context.js";
import { FooterWrapper as a } from "./styles.js";
const d = ({
  client_id: o = "",
  loginUrl: t = "",
  redirect_uri: e = "",
  linkTarget: m,
  showLogin: p = !1,
  authStore: i
}) => /* @__PURE__ */ r(a, { children: p && /* @__PURE__ */ r(
  f,
  {
    client_id: o,
    loginUrl: t,
    redirect_uri: e,
    linkTarget: m,
    authStore: i
  }
) });
export {
  d as default
};
